export const messages = {
  en: {
    role: {
      title: 'Role Management',
      addTitle: 'Add Role',
      editTitle: 'Edit Role',
      deleteTitle: 'Delete Role',
      name: 'Role Name',
      description: 'Description',
      privilege: 'Privilege',
      shop: 'Shop',
      staff: 'Staff',
      confirmDelete: 'Are you sure to delete this role?',
      deleteTip: 'Deleting the role will also delete all permissions under the role',
      addSuccess: 'Add role successfully',
      editSuccess: 'Edit role successfully',
      deleteSuccess: 'Delete role successfully'
    },
    roleShop: {
      title: 'Shop Authorization',
      shopId: 'Shop ID',
      shopName: 'Shop Name',
      operation: 'Operation',
      addShop: 'Add Shop',
      deleteShop: 'Delete Shop',
      confirmDelete: 'Are you sure to cancel authorization?'
    },
    roleStaff: {
      title: 'Staff Association',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      gender: 'Gender',
      operation: 'Operation',
      addStaff: 'Add Staff',
      deleteStaff: 'Delete Staff',
      detail: 'Detail',
      confirmDelete: 'Are you sure to cancel association?'
    }
  },
  zh: {
    role: {
      title: '角色管理',
      addTitle: '添加角色',
      editTitle: '编辑角色',
      deleteTitle: '删除角色',
      name: '角色名称',
      description: '角色描述',
      privilege: '功能授权',
      shop: '店铺授权',
      staff: '员工关联',
      confirmDelete: '确定删除该角色吗？',
      deleteTip: '删除角色同时会删除角色下的所有权限',
      addSuccess: '添加角色成功',
      editSuccess: '编辑角色成功',
      deleteSuccess: '删除角色成功'
    },
    roleShop: {
      title: '店铺授权',
      shopId: '店铺编号',
      shopName: '店铺名称',
      operation: '操作',
      addShop: '关联店铺',
      deleteShop: '删除店铺',
      confirmDelete: '确定取消授权吗？'
    },
    roleStaff: {
      title: '员工关联',
      name: '名称',
      phone: '手机号',
      email: '邮箱',
      address: '地址',
      gender: '性别',
      operation: '操作',
      addStaff: '关联员工',
      deleteStaff: '删除员工',
      detail: '详情',
      confirmDelete: '确定取消关联吗？'
    }
  }
}